export type OnboardingVideo = {
  id: string;
  title: string;
  duration: string; // mm:ss
  url: string;
  thumbnail?: string;
};

// TODO: replace with a videos API when one is available. Static placeholder
// content mirroring the Product Overview design.
export const ONBOARDING_VIDEOS: OnboardingVideo[] = [
  {
    id: "li-introduction",
    title: "LI Introduction",
    duration: "00:50",
    url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  },
  {
    id: "how-to-add-dataset",
    title: "How to Add a Dataset",
    duration: "02:10",
    url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  }
];
